const prefix = "SANDBOX_";

export const CREATE_FAILED = prefix + "CREATE_FAILED";
export const CREATE_STARTED = prefix + "CREATE_STARTED";
export const CREATE_SUCCEEDED = prefix + "CREATE_SUCCEEDED";
export const DELETE_FAILED = prefix + "DELETE_FAILED";
export const DELETE_STARTED = prefix + "DELETE_STARTED";
export const DELETE_SUCCEEDED = prefix + "DELETE_SUCCEEDED";
export const LOAD_ORIGINAL_LEVY_COLLECTION_FAILED = prefix + "LOAD_ORIGINAL_LEVY_COLLECTION_FAILED";
export const LOAD_ORIGINAL_LEVY_COLLECTION_STARTED = prefix + "LOAD_ORIGINAL_LEVY_COLLECTION_STARTED";
export const LOAD_ORIGINAL_LEVY_COLLECTION_SUCCEEDED = prefix + "LOAD_ORIGINAL_LEVY_COLLECTION_SUCCEEDED";
export const STATE_HIDE_ERROR = prefix + "STATE_HIDE_ERROR";
export const STATE_RESET = prefix + "STATE_RESET";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
export const UPDATE_TOGGLES = prefix + "UPDATE_TOGGLES";
